import { observable, computed, makeObservable } from "mobx";
import BreakpointStore from "../stores/BreakpointStore";
import { PillarModel, PillarArticleModel } from "../models/PillarModel";
import { ContentPillarsModel } from "../models/ContentPillarsModel";
import { ContentArticlesModel } from "../models/ContentArticlesModel";
import isEqual from "lodash/isEqual";
import filter from "lodash/filter";

export default class StoriesStore {
  @observable breakpoint: BreakpointStore = new BreakpointStore();

  @observable pillars: PillarModel[] = ContentPillarsModel;
  @observable articles: PillarArticleModel[] = ContentArticlesModel;

  @observable isScrollHintDismissed: boolean = false;
  scrollHintTimeout = null;

  @observable selectedPillar: PillarModel = null;
  @computed
  get isAnyPillarSelected(): boolean {
    return !!this.selectedPillar;
  }

  @computed
  get selectedPillarArticles(): PillarArticleModel[] {
    if (!this.isAnyPillarSelected) return null;
    return this.getPillarArticles(this.selectedPillar);
  }

  constructor() {
    makeObservable(this);
    this.selectPillar = this.selectPillar.bind(this);
    this.deselectPillar = this.deselectPillar.bind(this);
    this.isPillarSelected = this.isPillarSelected.bind(this);
    this.dismissScrollHint = this.dismissScrollHint.bind(this);
  }

  selectPillar(pillar: PillarModel): PillarModel {
    return (this.selectedPillar = pillar);
  }

  deselectPillar(): void {
    this.selectedPillar = null;
  }

  isPillarSelected(pillar: PillarModel): boolean {
    function filterHandle(value: string, key: string): boolean {
      if (key === "introText") return false;
      return true;
    }

    //Compare but remove stuff we don't need to check for performance
    const provided = filter(pillar, filterHandle);
    const active = filter(this.selectedPillar, filterHandle);

    return isEqual(provided, active);
  }

  getPillarArticles(pillar: PillarModel): PillarArticleModel[] {
    const articles = this.articles.filter(
      (article: PillarArticleModel): boolean => {
        return article.pillarId === pillar.id;
      }
    );

    return articles;
  }

  dismissScrollHint(immediate?: boolean | false): void {
    const timeoutTime = immediate ? 0 : 5000;
    if (!this.isScrollHintDismissed) {
      this.scrollHintTimeout = setTimeout(() => {
        this.isScrollHintDismissed = true;
      }, timeoutTime);
    }
  }
}
